import React, { useState } from 'react';
import { Link, Outlet, useNavigate, useLocation } from 'react-router-dom';
import 'startbootstrap-sb-admin-2/css/sb-admin-2.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '../styles/admin-custom.css';
import '../styles/tailadmin.css';
import NotificationDropdown from './common/NotificationDropdown';

const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarToggled, setSidebarToggled] = useState(true);
    const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userType');
    navigate('/admin/login');
  };

  return (
    <div id="wrapper">
      {/* Sidebar */}
      <ul className={`navbar-nav bg-gradient-primary sidebar sidebar-dark accordion ${sidebarToggled ? 'toggled' : ''}`} id="accordionSidebar">
        
        {/* Sidebar - Brand */}
        <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/admin/dashboard">
          <div className="sidebar-brand-icon rotate-n-15">
            <i className="fas fa-laugh-wink"></i>
          </div>
          <div className="sidebar-brand-text mx-3">Ticketaty <sup>Admin</sup></div>
        </Link>

        {/* Divider */}
        <hr className="sidebar-divider my-0" />

        {/* Nav Item - Dashboard */}
        <li className={`nav-item ${location.pathname === '/admin/dashboard' ? 'active' : ''}`}>
          <Link className="nav-link" to="/admin/dashboard" data-title="Dashboard">
            <i className="fas fa-fw fa-tachometer-alt"></i>
            <span>Dashboard</span>
          </Link>
        </li>

        {/* Divider */}
        <hr className="sidebar-divider" />

        {/* Heading */}
        <div className="sidebar-heading">
          Management
        </div>

        {/* Nav Item - Events */}
        <li className={`nav-item ${location.pathname === '/admin/events' ? 'active' : ''}`}>
          <Link className="nav-link" to="/admin/events" data-title="Events">
            <i className="fas fa-fw fa-calendar"></i>
            <span>Events</span>
          </Link>
        </li>

        {/* Nav Item - Organizers */}
        <li className={`nav-item ${location.pathname === '/admin/organizers' ? 'active' : ''}`}>
          <Link className="nav-link" to="/admin/organizers" data-title="Organizers">
            <i className="fas fa-fw fa-users"></i>
            <span>Organizers</span>
          </Link>
        </li>

        {/* Nav Item - Users */}
        <li className={`nav-item ${location.pathname === '/admin/users' ? 'active' : ''}`}>
          <Link className="nav-link" to="/admin/users" data-title="Users">
            <i className="fas fa-fw fa-user"></i>
            <span>Users</span>
          </Link>
        </li>

        {/* Nav Item - Categories */}
        <li className={`nav-item ${location.pathname === '/admin/categories' ? 'active' : ''}`}>
          <Link className="nav-link" to="/admin/categories" data-title="Categories">
            <i className="fas fa-fw fa-tags"></i>
            <span>Categories</span>
          </Link>
        </li>

        {/* Nav Item - Orders */}
        <li className={`nav-item ${location.pathname === '/admin/orders' ? 'active' : ''}`}>
          <Link className="nav-link" to="/admin/orders" data-title="Orders">
            <i className="fas fa-fw fa-shopping-cart"></i>
            <span>Orders</span>
          </Link>
        </li>

        {/* Nav Item - Seat Map Templates */}
        <li className={`nav-item ${location.pathname.startsWith('/admin/seat-map-templates') ? 'active' : ''}`}>
          <Link className="nav-link" to="/admin/seat-map-templates" data-title="Seat Map Templates">
            <i className="fas fa-fw fa-map"></i>
            <span>Seat Map Templates</span>
          </Link>
        </li>

        {/* Divider */}
        <hr className="sidebar-divider" />

        {/* Heading */}
        <div className="sidebar-heading">
          Financial
        </div>

        {/* Nav Item - Financial Reports */}
        {/*<li className={`nav-item ${location.pathname === '/admin/financial' ? 'active' : ''}`}>*/}
        {/*  <Link className="nav-link" to="/admin/financial" data-title="Financial Reports">*/}
        {/*    <i className="fas fa-fw fa-chart-line"></i>*/}
        {/*    <span>Financial Reports</span>*/}
        {/*  </Link>*/}
        {/*</li>*/}

        {/* Nav Item - Payout Requests */}
        <li className={`nav-item ${location.pathname === '/admin/payouts' ? 'active' : ''}`}>
          <Link className="nav-link" to="/admin/payouts" data-title="Payout Requests">
            <i className="fas fa-fw fa-money-check"></i>
            <span>Payout Requests</span>
          </Link>
        </li>

        {/* Divider */}
        <hr className="sidebar-divider" />

        {/* Heading */}
        <div className="sidebar-heading">
          Settings
        </div>

        {/* Nav Item - Settings */}
        <li className={`nav-item ${location.pathname === '/admin/settings' ? 'active' : ''}`}>
          <Link className="nav-link" to="/admin/settings" data-title="Settings">
            <i className="fas fa-fw fa-cog"></i>
            <span>Settings</span>
          </Link>
        </li>

        {/* Divider */}
        <hr className="sidebar-divider d-none d-md-block" />

        {/* Sidebar Toggler */}
        <div className="text-center d-none d-md-inline">
          <button 
            className="rounded-circle border-0" 
            id="sidebarToggle"
            onClick={() => setSidebarToggled(!sidebarToggled)}
          ></button>
        </div>

      </ul>
      {/* End of Sidebar */}

      {/* Content Wrapper */}
      <div id="content-wrapper" className="d-flex flex-column">

        {/* Main Content */}
        <div id="content">

          {/* Topbar */}
          <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

            {/* Sidebar Toggle (Topbar) */}
            <button 
              id="sidebarToggleTop" 
              className="btn btn-link d-md-none rounded-circle mr-3"
              onClick={() => setSidebarToggled(!sidebarToggled)}
            >
              <i className="fa fa-bars"></i>
            </button>

            {/* Topbar Navbar */}
            <ul className="navbar-nav ml-auto">

              {/* Notifications */}
              {/*<NotificationDropdown userType="admin" />*/}

                <button className="" onClick={handleLogout}>
                    <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                    Logout
                </button>

              <div className="topbar-divider d-none d-sm-block"></div>

              {/* Nav Item - User Information */}
              <li className="nav-item mr-4 dropdown no-arrow">
                <a className="nav-link dropdown-toggle" href="#" id="userDropdown" role="button"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <span className="mr-2 d-none d-lg-inline text-gray-600 small">Admin User</span>
                  <img className="img-profile rounded-circle"
                    src="https://ui-avatars.com/api/?name=Admin&background=4e73df&color=fff" alt="Admin"
                    style={{cursor: 'pointer'}} onClick={(e) => { e.stopPropagation(); navigate('/admin/profile'); }} />
                </a>
                {/* Dropdown - User Information */}
                <div className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
                  aria-labelledby="userDropdown">
                  <Link className="dropdown-item" to="/admin/profile">
                    <i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
                    Profile
                  </Link>
                  <Link className="dropdown-item" to="/admin/settings">
                    <i className="fas fa-cogs fa-sm fa-fw mr-2 text-gray-400"></i>
                    Settings
                  </Link>
                  <div className="dropdown-divider"></div>
                  <button className="dropdown-item" onClick={handleLogout}>
                    <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                    Logout
                  </button>
                </div>
              </li>

            </ul>

          </nav>
          {/* End of Topbar */}

          {/* Begin Page Content */}
          <div className="container-fluid">
            <Outlet />
          </div>
          {/* /.container-fluid */}

        </div>
        {/* End of Main Content */}

        {/* Footer */}
        <footer className="sticky-footer bg-white">
          <div className="container my-auto">
            <div className="copyright text-center my-auto">
              <span>Copyright &copy; Ticketaty {new Date().getFullYear()}</span>
            </div>
          </div>
        </footer>
        {/* End of Footer */}

      </div>
      {/* End of Content Wrapper */}

    </div>
  );
};

export default AdminLayout;

